import React, { useState, useEffect, useRef } from 'react';
import { addZeroToDigit } from '../helper/TimerHelpers';
import { useWindowDimensions } from '../../../utilities/Dimensions';
import { SessionTimerTypes } from '../SessionTimerTypes';
import { generalSessionTimerConstants } from '../constants/generalConstants';
import { tabletscreensize } from '../../../utilities/constants';
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';
import { ResponsiveSessionTimer } from './ResponsiveSessionTimer';
import { Text } from '../../textVariations';
import { SessionExpiryWarningModal } from './SessionExpiryWarningModal';
import {
  makeBackgroundClickable,
  makeModalBackgroundUnClickable,
} from '../../../sections/account/helpers/accountPanelModalHelper';

export const SessionTimeOutTimer = ({
  percentages,
  totalSeconds,
  interval,
  bodyHeight,
  logOutHandler,
  contextObj,
  sessionExtendCallHandler,
}: SessionTimerTypes.TSessionTimeOutTimer) => {
  const [currIndex, setCurrIndex] = useState(contextObj?.currSessionTime || 0);
  const [showWarningModal, setShowWarningModal] = useState<Boolean | undefined>(
    false
  );
  const { width } = useWindowDimensions();
  const { warningLimitInSeconds, minutesLabel } = generalSessionTimerConstants;
  const minutes = Math.floor((totalSeconds - currIndex) / 60);
  const seconds = (totalSeconds - currIndex) % 60;
  const savedCallBack = useRef<any>();
  const currRef = useRef<any>();

  const callback = () => {
    setCurrIndex((currIndex + 1) % percentages.length);
  };

  useEffect(() => {
    savedCallBack.current = callback;
  });

  useEffect(() => {
    const tick = () => {
      savedCallBack.current();
    };
    const timerId = setInterval(tick, interval);

    return () => {
      if (!location.pathname.includes('login')) {
        contextObj.setCurrSessionTime(currRef.current);
      } else {
        contextObj.setCurrSessionTime(0);
      }
      currRef.current = 0;
      clearInterval(timerId);
    };
  }, []);

  const showModal = () => {
    if (showWarningModal === true) {
      makeModalBackgroundUnClickable();
    } else if (
      showWarningModal === false &&
      currIndex + warningLimitInSeconds === totalSeconds
    ) {
      makeBackgroundClickable();
    }
  };

  useEffect(() => {
    showModal();
    currRef.current = currIndex;
    if (currIndex + warningLimitInSeconds === totalSeconds) {
      setShowWarningModal(true);
    }
    if (currIndex === totalSeconds) {
      setShowWarningModal(false);
      logOutHandler(true);
    }

    return () => {
      if (typeof showWarningModal === 'boolean') {
        document.body.style.overflowY = '';
        document.body.style.position = 'static';
      }
    };
  }, [showWarningModal, currIndex]);

  const modalCloseHandler = () => {
    setShowWarningModal(false);
  };

  return (
    <>
      {width > tabletscreensize ? (
        <CircularProgressbarWithChildren
          value={percentages[currIndex]}
          background
        >
          <div className="circularProgressBarText">
            <Text renderAs={'p'} className="timer">
              {addZeroToDigit(minutes)} : {addZeroToDigit(seconds)}
            </Text>
            <Text renderAs={'p'} className="timerLabel">
              {minutesLabel}
            </Text>
          </div>
        </CircularProgressbarWithChildren>
      ) : (
        <ResponsiveSessionTimer minutes={minutes} seconds={seconds} />
      )}
      {showWarningModal && (
        <SessionExpiryWarningModal
          minutes={minutes}
          seconds={seconds}
          bodyHeight={bodyHeight}
          closeHandler={modalCloseHandler}
          sessionExtendCallHandler={sessionExtendCallHandler}
          currentCount={setCurrIndex}
        />
      )}
    </>
  );
};
